<template>
  <div class="h-screen flex flex-col bg-grey-100">
    <div
      class="flex flex-row w-full bg-white h-16 border-solid border-grey-200 border-b px-5"
    >
      <div class="flex flex-grow items-center h-16 container mx-auto">
        <slot name="header-bar"></slot>
      </div>
    </div>
    <div
      v-if="menuOpen"
      class="absolute w-64 bg-white right-0 top-0 mt-13 rounded-lg z-40 border-solid border border-grey-200 shadow"
      v-on-click-outside="closeMenu"
    >
      <div class="px-4 py-2">
        <div
          v-for="item in menuItems"
          @click="callMenuAction(item)"
          :key="item.text"
          class="cursor-pointer text-grey-700 mb-2 text-sm"
        >
          <hr v-if="item.text === 'ruler'" class="border-t-1 border-grey-100" />
          <span v-else>{{ item.text }}</span>
        </div>
      </div>
    </div>
    <div class="flex w-full h-full">
      <div class="flex flex-row w-full max-h-full">
        <slot name="content"></slot>
      </div>
    </div>
  </div>
</template>

<script>
import GdLogo from '@groovepages/gd-ui-kit/assets/logo-extra-small.svg';
import directives from '@groovepages/gd-ui-kit/directives';

export default {
  props: ['menuItems'],
  data() {
    return {
      menuOpen: false,
    };
  },
  methods: {
    toggleMenu() {
      this.menuOpen = !this.menuOpen;
    },
    closeMenu() {
      this.menuOpen = false;
    },
    callMenuAction(menuItem) {
      this.menuOpen = false;
      menuItem.callback();
    },
  },
  components: {
    GdLogo,
  },
  directives,
  name: 'BaseLayout',
};
</script>
